import React from "react";
import Footer from "../footer/Footer";
import VTAdminDashboardEdit from "../page/VTAdminDashboardEdit";
import Header from "../header/Header";

/**
 * Edit Venue Profile
 *
 * @param page
 * @returns {JSX.Element}
 * @constructor
 */
export default function LandingAdminDashboardEdit({page}) {
    return (
        <>
            <Header headerType="AdminOnly"/>
            <VTAdminDashboardEdit/>
            <Footer/>
        </>
    );
}